import { useBreakpointValue } from "@chakra-ui/react";
import Table from "@splitfire-agency/raiden-library/dist/components/Table";
import Tbody from "@splitfire-agency/raiden-library/dist/components/Table/Tbody";
import Th from "@splitfire-agency/raiden-library/dist/components/Table/Th";
import Thead from "@splitfire-agency/raiden-library/dist/components/Table/Thead";
import Tr from "@splitfire-agency/raiden-library/dist/components/Table/Tr";
import { useIntl } from "react-intl";
import Row from "./Row";

/**
 * @param {object} params
 * @param {import("../../../types/Document").Document} params.document
 * @param {import("../../../types/CustomerDocument").CustomerDocument[]} params.customerDocuments
 *
 * @return {import("../../../types/CustomerDocument").CustomerDocument | undefined}
 */
function resolveCustomerDocument({ document, customerDocuments }) {
  return customerDocuments.find(
    (customerDocument) => customerDocument.document_id === document.id,
  );
}

/**
 * @typedef {object} Props
 * @property {"customer" | "holder"} userType
 * @property {number} userId
 * @property {import("../../../types/Document").Document[]} documents
 * @property {import("../../../types/CustomerDocument").CustomerDocument[]} customerDocuments
 * @property {() => void} mutateCustomerDocuments
 *
 * @param {Props} props
 */
function CustomersDocumentsTable({
  userType,
  userId,
  documents,
  mutateCustomerDocuments,
  customerDocuments,
}) {
  const intl = useIntl();

  const responsive = useBreakpointValue({
    base: true,
    xl: false,
  });

  return (
    <Table variant="striped" layout={responsive ? "column" : "row"}>
      <Thead>
        <Tr>
          <Th
            // @ts-ignore
            w="33%">
            {intl.formatMessage({ defaultMessage: "Nom" })}
          </Th>

          <Th
            // @ts-ignore
            w="33%">
            {intl.formatMessage({ defaultMessage: "Statut" })}
          </Th>

          <Th>{intl.formatMessage({ defaultMessage: "Actions" })}</Th>
        </Tr>
      </Thead>

      <Tbody>
        {documents.map((document) => (
          <Row
            userType={userType}
            userId={userId}
            document={document}
            mutateCustomerDocument={mutateCustomerDocuments}
            customerDocument={resolveCustomerDocument({
              document,
              customerDocuments,
            })}
            key={document.id}
          />
        ))}
      </Tbody>
    </Table>
  );
}

export default CustomersDocumentsTable;
